import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { HelpApp } from "@/help/HelpApp";

const mount = document.getElementById("help-app-mount");
const fallback = document.getElementById("help-toc-fallback");

if (mount) {
  fallback?.classList.add("hidden");
  mount.classList.remove("hidden");
  createRoot(mount).render(
    <StrictMode>
      <HelpApp />
    </StrictMode>,
  );
}
